import { useRef } from 'react'
import { formatIN, useCountUp, useTilt } from './motion'

// A number first, then what it counts, and the whole tile opens the list it
// counts.
//
// # WHY IT IS A LINK
//
// A tile that only shows a number sends the reader looking for where those
// items are. The spec accepts a screen only when every count on it matches the
// list it opens, and making the tile that link is what lets anyone check. The
// accessible name is the label and the final value, so a screen reader hears
// "Decisions waiting for you: 4" and not the frames of the count.

export function KpiTile({ value, label, href, hot }: { value: number; label: string; href: string; hot?: boolean }) {
  const shown = useCountUp(value)
  const tile = useRef<HTMLAnchorElement>(null)
  useTilt(tile, { max: 5 })
  return (
    <a ref={tile} className={'kit-tile' + (hot ? ' kit-hot' : '')} href={href} aria-label={label + ': ' + value}>
      <span className="kit-tile-n" aria-hidden="true">
        {formatIN(shown)}
      </span>
      <span className="kit-tile-l" aria-hidden="true">
        {label}
      </span>
    </a>
  )
}
